import { Lock } from '@/components/icons'
import { useTranslation } from 'react-i18next'

/** Lock mark rendered in place of a hidden numeric rating. */
export const LockedRating = ({ className = 'w-3 h-3' }: { className?: string }) => {
  const { t } = useTranslation()
  return <Lock className={`inline-block text-navy-900 opacity-40 ${className}`} aria-label={t('player.ratingLocked')} />
}
